import React from 'react';
import { AccountingData } from '../../../hooks/accounting/useAccountingData';
import { TaskDropdown } from '../styles';
import TaskFilterControls from './TaskFilterControls';
import TaskFilterOptions from './TaskFilterOptions';

interface TaskFilterDropdownContentProps {
  accounting: AccountingData;
}

const TaskFilterDropdownContent: React.FC<TaskFilterDropdownContentProps> = ({ accounting }) => (
  <TaskDropdown>
    <TaskFilterControls accounting={accounting} />
    <TaskFilterOptions accounting={accounting} />
  </TaskDropdown>
);

export default TaskFilterDropdownContent;
